import React, { ReactElement, Suspense } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { MainLayout } from '../layouts';
import { InterceptorService } from '../services/interceptrors-service';
import { MainLoader } from '../components';

export function PrivateRouter(): ReactElement {
  const navigate = useNavigate();

  InterceptorService.setHistory(navigate);

  return (
    <MainLayout>
      <Suspense fallback={<MainLoader fullContent />}>
        <Outlet />
      </Suspense>
    </MainLayout>
  );
}
